export const THEME_COLORS = {
  background: '#0E0352', // Also update in index.scss for body element
  backgroundForm: '#11056c',
  backgroundLight: '#FDDDFC',
  //
  brandPink: '#F63690',
  brandPinkFaded: '#EF60A3',
  brandYellow: '#FFB443',
  brandTeal: '#32A19F',
  //
  text: '#EEE',
  textBlue: '#CBCDFF',
  textDim: '#767683',
  darkText: '#222',
};
